window.RcmShoppingCartImageDisplay = function (instanceId) {
    var me = this;

    /**
     * jQuery container div that wraps this plugin
     * @type {jQuery}
     */
    var container = $('div[data-rcmPluginInstanceId=' + instanceId + ']');

    var listContainer = container.find('.rcmProductImageList');
    var largeCont = container.find('.large');
    var smallCont = container.find('.small');
    //var zoomerCont = container.find('.zoomer');
    var largeImg = largeCont.find('img');

    this.init = function () {

        me.getDefaultImages();

        me.renderImages();

        me.startZoomer();

        me.renderImages();

        //Listen for the add-to-cart button to select skus and change to the correct sku image
        document.getElementsByTagName('body')[0].addEventListener(
            'BlockRcmAddToCartButton-skuSelected',
            function (event) {
                var skuNumber = event.detail.skuNumber;
                var skus = window.pageProduct.skus;
                var sku;
                for (var i = 0; i < skus.length; i++) {
                    if (skus[i].skuNumber === skuNumber) {
                        sku = skus[i];
                        break;
                    }
                }
                me.changeImage(sku);
            }
        );
    };

    this.changeImage = function (sku) {
        if (!sku) {
            return;
        }

        var images = sku.getImages();

        if (!images) {
            images = [new RcmShoppingCartImage()];
        }

        me.imageList = images;

        me.renderImages();
        largeImg.load(function () {
            me.startZoomer();
        });
    };

    this.startZoomer = function () {
        //var hasHighRes = zoomerCont.data('hasHighRes');
        //if (hasHighRes == 'Y') {
        //    zoomerCont.anythingZoomer();
        //}
    };

    this.getDefaultImages = function () {
        var initialProduct = pageProduct;

        if (!initialProduct) {
            me.setupWithOutImages();
            return;
        }

        var defaultSku = initialProduct.getDefaultSku();

        if (!defaultSku) {
            me.setupWithOutImages();
            return;
        }

        me.imageList = defaultSku.getImages();
    };

    this.renderImages = function () {
        if (me.imageList.length < 1) {
            me.setupWithOutImages();
            return;
        }

        $(listContainer).find('li').remove();
        me.changeMainSrc(me.imageList[0]);

        if (me.imageList.length > 1) {
            $.each(me.imageList, function (i, image) {
                me.addImage(image);
            });
            $(listContainer).show();
        } else {
            $(listContainer).hide();
        }
    };

    this.changeMainSrc = function (image) {
        smallCont.find('img').attr('src', image.getImageSrc());

        if (image.getHighResSrc() != '') {
            largeImg.attr('src', image.getHighResSrc());
            largeImg.click(function () {
                $.colorbox({ href: image.getHighResSrc() });
            });
            //zoomerCont.data('hasHighRes', 'Y');
            largeCont.show();
            //zoomerCont.anythingZoomer('enable');
        } else {
            largeImg.attr('src', image.getImageSrc());
            largeImg.click(function () {
                $.colorbox({ href: image.getImageSrc() });
            });
            //zoomerCont.data('hasHighRes', 'N');
            largeCont.hide();
            //zoomerCont.anythingZoomer('disable');
        }
    };

    this.addImage = function (image) {
        var newLi = $('<li></li>')
            .addClass('productImageLi')
            .css('cursor', 'pointer')
            .click(me.imageClickBind)
            .data('image', image);

        var thumbnail = $('<img>');
        var newCaption = $('<div></div>').text(image.getCaption());

        thumbnail.attr('src', image.getThumbSrc()).height($(listContainer).height());

        newLi.append(thumbnail, $('<br />'), newCaption);

        listContainer.append(newLi);

    };

    this.imageClickBind = function () {
        var imageData = $(this).data('image');
        me.changeMainSrc(imageData);
    };

    this.setupWithOutImages = function () {
        me.imageList = [new RcmShoppingCartImage()];
    };

    this.init();
}
